import React from 'react';
import NextButton from './NextButton';

const SaksClue: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p>Time to treat yo self and splurge on something nice!</p>
      <img style={{ width: '100%' }} src='splurge.jpg' />
      <p>Head over to Saks for your next clue</p>
      <NextButton acceptedClues={[]} text="I'm here" />
    </div>
  );
};

export default SaksClue;
